// Portfolio dei lavori realizzati
import React from 'react';
import { optimizeImageUrl } from '../../utils/imageUrl';
import { useShop } from '../ShopContext';
import { PageHeader, Section } from '../ShopUi';

export default function ShopPortfolio() {
  const { portfolio, style } = useShop();
  return (
    <div data-testid="shop-portfolio">
      <PageHeader title="Portfolio" subtitle="Alcuni dei lavori realizzati in bottega." />
      <Section>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {portfolio.map((item) => (
            <figure key={item.id}>
              <div className={`aspect-[4/3] ${style.media} overflow-hidden bg-slate-100`}>
                <img src={optimizeImageUrl(item.image_url, 800)} alt={item.title} className="w-full h-full object-cover" />
              </div>
              <figcaption className="mt-3">
                <p className={`${style.heading} text-lg text-slate-900`}>{item.title}</p>
                {item.description && <p className="text-sm text-slate-500 mt-1">{item.description}</p>}
              </figcaption>
            </figure>
          ))}
        </div>
      </Section>
    </div>
  );
}
